import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription } from './components/ui/card';
import { Upload, TrendingUp, RefreshCw, Store, PackageCheck, Coffee } from 'lucide-react';
import { useNavigation } from './contexts/NavigationContext';

function ManageStock() {
  const { navigate } = useNavigation();
  return (
    <main className="w-full px-4 py-8 space-y-8 max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="space-y-2 text-left">
          <h1 className="text-4xl font-bold text-left">Manage Stock</h1>
          <p className="text-base text-muted-foreground text-left">Stock management operations</p>
        </div>

        {/* Action Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          
          <Card 
            className="cursor-pointer hover:shadow-xl hover:scale-[1.02] hover:border-primary transition-all group"
            onClick={() => navigate('uploadInvoice')}
          >
            <CardHeader className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="h-14 w-14 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary group-hover:scale-110 transition-all">
                  <Upload className="h-7 w-7 text-primary group-hover:text-primary-foreground transition-colors" />
                </div>
                <div className="flex-1 space-y-1.5 text-left">
                  <CardTitle className="text-left">Upload Invoice</CardTitle>
                  <CardDescription className="text-left">Upload government invoice PDF to automatically update stock</CardDescription>
                </div>
              </div>
            </CardHeader>
          </Card>

          <Card 
            className="cursor-pointer hover:shadow-xl hover:scale-[1.02] hover:border-primary transition-all group"
            onClick={() => navigate('indentEstimate')}
          >
            <CardHeader className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="h-14 w-14 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary group-hover:scale-110 transition-all">
                  <TrendingUp className="h-7 w-7 text-primary group-hover:text-primary-foreground transition-colors" />
                </div>
                <div className="flex-1 space-y-1.5 text-left">
                  <CardTitle className="text-left">Indent Estimate</CardTitle>
                  <CardDescription className="text-left">Estimate the value of products to be purchased</CardDescription>
                </div>
              </div>
            </CardHeader>
          </Card>

          <Card 
            className="cursor-pointer hover:shadow-xl hover:scale-[1.02] hover:border-primary transition-all group"
            onClick={() => navigate('shiftTransfer')}
          >
            <CardHeader className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="h-14 w-14 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary group-hover:scale-110 transition-all">
                  <RefreshCw className="h-7 w-7 text-primary group-hover:text-primary-foreground transition-colors" />
                </div>
                <div className="flex-1 space-y-1.5 text-left">
                  <CardTitle className="text-left">Stock Transfer</CardTitle>
                  <CardDescription className="text-left">Transfer stock between suppliers and shops</CardDescription>
                </div>
              </div>
            </CardHeader>
          </Card>

          <Card 
            className="cursor-pointer hover:shadow-xl hover:scale-[1.02] hover:border-primary transition-all group"
            onClick={() => navigate('addStore')}
          >
            <CardHeader className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="h-14 w-14 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary group-hover:scale-110 transition-all">
                  <Store className="h-7 w-7 text-primary group-hover:text-primary-foreground transition-colors" />
                </div>
                <div className="flex-1 space-y-1.5 text-left">
                  <CardTitle className="text-left">Add Store</CardTitle>
                  <CardDescription className="text-left">Add and manage store information</CardDescription>
                </div>
              </div>
            </CardHeader>
          </Card>

          <Card 
            className="cursor-pointer hover:shadow-xl hover:scale-[1.02] hover:border-primary transition-all group"
            onClick={() => navigate('stockReceived')}
          >
            <CardHeader className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="h-14 w-14 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary group-hover:scale-110 transition-all">
                  <PackageCheck className="h-7 w-7 text-primary group-hover:text-primary-foreground transition-colors" />
                </div>
                <div className="flex-1 space-y-1.5 text-left">
                  <CardTitle className="text-left">Stock Received</CardTitle>
                  <CardDescription className="text-left">View all received stock records with source tracking</CardDescription>
                </div>
              </div>
            </CardHeader>
          </Card>

          <Card 
            className="cursor-pointer hover:shadow-xl hover:scale-[1.02] hover:border-primary transition-all group"
            onClick={() => navigate('accessories')}
          >
            <CardHeader className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="h-14 w-14 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary group-hover:scale-110 transition-all">
                  <Coffee className="h-7 w-7 text-primary group-hover:text-primary-foreground transition-colors" />
                </div>
                <div className="flex-1 space-y-1.5 text-left">
                  <CardTitle className="text-left">Accessories</CardTitle>
                  <CardDescription className="text-left">Manage cool drinks, water bottles, and other accessories</CardDescription>
                </div>
              </div>
            </CardHeader>
          </Card>

        </div>
      </main>
  );
}

export default ManageStock;